interface JsonLdProps {
    data: Record<string, unknown> | Record<string, unknown>[];
    id?: string;
}

const JsonLd = ({data, id}: JsonLdProps) => (
    <script type="application/ld+json" id={id} dangerouslySetInnerHTML={{__html: JSON.stringify(data)}} />
);

export default JsonLd;
